import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccountService } from '@banyan/features/account/services/account.service';
import { OAuthService } from 'angular-oauth2-oidc';

export const adminGuard: CanActivateFn = async (route, state) => {
  const accountService = inject(AccountService);
  const oauthService = inject(OAuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  await oauthService.loadDiscoveryDocumentAndTryLogin();
  if (!oauthService.hasValidAccessToken()) {
    if (isPlatformBrowser(platformId)) {
      window.localStorage.setItem('Url', state.url);
    }
    oauthService.initLoginFlow();
    return false;
  }
  const user = accountService.user();

  if (user.isAuthenticated) {
    if (user.isAdmin) {
      return true;
    } else {
      router.navigate(['/error']).then();
      return false;
    }
  }
  if (isPlatformBrowser(platformId)) {
    window.localStorage.setItem('Url', state.url);
  }
  accountService.checkLoginStatus();
  return false;
};
